// Hooks
import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

// Constants/Libs
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import { ConversationFilters } from '@/components/pages/conversations/SocialInbox';
import { DirectMessageFilters } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMessageList/SocialInboxHeader/SocialInboxFilters/DirectMessageFilters';
export const SocialInboxFilters = () => {
    const { currentSocialInbox } = useSocialInboxNavigation();

    if (currentSocialInbox === SOCIAL_INBOX_META.dm.key) {
        return <DirectMessageFilters />;
    }

    return <ConversationFilters />;
};
